import React from "react";
import PropTypes from "prop-types";

const RequestStatusFormatter = ({ row }) => {
  if (row?.requestStatus === "Request Required") {
    // make text red
    return <div style={{ color: "red" }}>{row.requestStatus}</div>;
  }
  return <div>{row?.requestStatus}</div>;
};

RequestStatusFormatter.propTypes = {
  row: PropTypes.object
};

export default RequestStatusFormatter;
